import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import Global from '../../../../../store/global-selectors';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import messages from '../../messages';

import styles from './styles.module.less';

const SentTestModal = ({ storeGuid }) => {
  const { email } = useSelector(Global.selectUserCurrentUserInfo);
  const { name } = useSelector((state) => Global.selectSellerStoreData(state, { storeGuid }));
  return (
    <Modal size='small'>
      <ModalHeader>
        <FormattedMessage {...messages.testEmailSent} />
      </ModalHeader>
      <ModalBody className={styles.body}>
        <div className={styles.line}>
          <div>
            <FormattedMessage {...messages.usedBranding} />
          </div>
          <div className={styles.target}>{name}</div>
        </div>
        <div className={styles.line}>
          <div>
            <FormattedMessage {...messages.sentTo} />
          </div>
          <div className={styles.target}>{email}</div>
        </div>
      </ModalBody>
    </Modal>
  );
};

SentTestModal.propTypes = {
  storeGuid: PropTypes.string.isRequired,
};

export default SentTestModal;
